<template>
  <b-container class="wrap-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to archive
        </button>
      </b-col>
    </b-row>

    <b-row v-if="archives" class="wrap-content">
      <div class="box-youtube">
        <iframe
          height="100%"
          width="100%"
          :src="`https://www.youtube.com/embed/${archives.link.split('/')[archives.link.split('/').length - 1]}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>

      <div class="box-list">
        <table>
          <tr v-if="categoryName !== 'ห้องอาจารย์ใหญ่' || archives.name">
            <td class="title">
              <div class="box"/>
              <p>Session</p>
            </td>
            <td class="dec">
              <p v-html="archives.name" />
            </td>
          </tr>
          <tr v-if="archives.name_lecturer !== 'null'">
            <td class="title">
              <div class="box"/>

              <p v-if="this.$route.params.categoryName.toLowerCase() === 'talk & symposium'">
                Speaker
              </p>
              <p v-if="this.$route.params.categoryName.toLowerCase() !== 'talk & symposium'">
                Mentor
              </p>
            </td>
            <td class="box-lec">
              <div
                v-for="lecturer in archives.name_lecturer"
                :key="lecturer.id"
                class="box-lecturer"
              >
                <span v-if="lecturer.name">
                  <span v-html="lecturer.name" />
                  <br>
                </span>
                <p v-if="lecturer.position">
                  <span v-html="lecturer.position" />
                  <br>
                </p>
                <span v-if="lecturer.company">
                  <span v-html="lecturer.company" />
                </span>
              </div>
            </td>
          </tr>

          <tr v-if="archives.name_host || archives.position_host || archives.company_host">
            <td class="title">
              <div class="box"/>

              <p
                v-if="
                  this.$route.params.categoryName.toLowerCase() === 'talk & symposium' ||
                  this.$route.params.categoryName === 'ห้องอาจารย์ใหญ่'
                "
              >
                Moderator
              </p>
              <p v-else>
                Master of Ceremonies
              </p>
            </td>
            <td class="box-lec">
              <div class="box-lecturer">
                <span v-if="archives.name_host">{{ archives.name_host }}<br></span>
                <span v-if="archives.position_host">{{ archives.position_host }}<br></span>
                <span v-if="archives.company_host">{{ archives.company_host }}</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </b-row>

    <b-row v-if="false" class="wrap-other">
      <h3 class="title">ผลงานอื่นๆที่เกี่ยวข้อง</h3>

      <div class="box-card">
        <b-row style="margin-left: 0; margin-right: 0;">
          <b-col
            v-for="index in 3"
            :key="index"
            :sm="12"
            :md="6"
            :lg="4"
            class="box-section"
          >
            <router-link to="/">
              <div class="wrap-image">
                <img
                  src="https://i.pinimg.com/originals/e6/39/ec/e639ec046727db4c702ef1f8ea177742.jpg"
                  alt=""
                >
              </div>
            </router-link>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      archives: null,
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Program Archive',
          to: {
            name: 'programArchive'
          }
        },
        {
          text: this.$route.params.categoryName.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase()),
          to: {
            name: 'programArchiveCategory',
            params: {
              year: this.$route.params.year,
              categoryName: this.$route.params.categoryName.toLowerCase()
            }
          }
        },
        {
          text: this.$route.params.name.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
        }
      ]
    }
  },

  computed: {
    ...mapState({
      categories: state => state.program.categories,
      rawArchives: state => state.program.archives
    }),

    year () {
      return this.$route.params.year
    },

    categoryName () {
      return this.$route.params.categoryName
    }
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  },

  watch: {
    categories (categories) {
      if (categories) {
        this.mapCategories(categories)
      }
    },

    rawArchives (rawArchives) {
      if (rawArchives) {
        this.archives = null

        rawArchives.forEach((archive) => {
          if (archive.name.toLowerCase() === decodeURI(decodeURI(this.$route.params.name).toLowerCase())) {
            fetch(`https://admanawards.com/newadmin/public/api/archivevideo/detail?id=${archive.id}`)
              .then(response => response.json())
              .then(data => {
                console.log(data)
                this.archives = data
              })
              .catch(err => {
                console.error(err)
              })
          }
        })
        // this.archives = rawArchives[0]
      }
    }
  },

  created () {
    if (this.categories.length === 0) {
      this.$store.dispatch('program/getCategory')
    } else {
      this.mapCategories(this.categories)
    }
  },

  methods: {
    goBack () {
      this.$router.push({
        name: 'programArchiveCategory',
        params: {
          year: this.year,
          categoryName: this.categoryName.toLowerCase()
        }
      })
    },

    mapCategories (categories) {
      categories.forEach((category) => {
        if (category.name.toLowerCase() === this.categoryName.toLowerCase()) {
          this.$store.dispatch('program/getArchives', {
            id: category.id,
            year: this.year
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-archive {
  .box-head {
      padding: 22px 0;
      border-bottom: 1px solid #CCC;

      .box-breadcrumb {
        display: flex;
        align-items: center;

        .breadcrumb {
          margin: 0;
          padding: 0;
          background: none;

          li {
            font-size: 1.25rem;

            a {
              color: black;
            }
          }
        }
      }

      .box-back-btn {
        margin-top: 22px;

        @media only screen and (min-width: $break-m) {
          margin-top: 0;
        }

        button {
          width: 100%;
          background-color: #CCC;
          padding: 12px 0;
          font-size: 1.25rem;
        }
      }
    }

  .wrap-content {
    padding-bottom: 12px;

    .box-youtube {
      overflow: hidden;
      position: relative;
      width: 100%;
      margin-top: 22px;
      padding-bottom: calc(56.25% + 42px);
      border-bottom: 1px solid #CCC;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-bottom: 42px;
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    .box-list {
      display: flex;
      justify-content: center;
      padding-top: 22px;
      padding-bottom: 22px;
      width: 100%;

      table {
        width: 80%;
        text-transform: uppercase;

        tr {
          display: flex;
          flex-direction: column;
          font-weight: 800;
          font-size: 28px;
          letter-spacing: 0.5px;

          @media only screen and (min-width: $break-m) {
            flex-direction: row;
          }

          .title {
            display: flex;
            align-items: center;
            width: 100%;
            height: 53px;
            font-family: 'DB Helvethaica X Med Cond';
            color: #BCBEC0;

            .box {
              width: 14px;
              height: 14px;
              background-color: #E10100;
            }

            p {
              margin-top: 2px;
              margin-left: 12px;
            }
          }

          .dec::before {
            content: ':';
            margin-right: 12px;
            font-size: 34px;
            font-weight: 800;
            color: #979697;
          }

          .dec {
            display: flex;
            padding-left: 28px;
            width: 100%;
            font-family: 'DB Helvethaica X 67 Cond';
            font-weight: 300;
            color: #979697;

            p {
              padding-top: 6px;
            }
          }

          // .box-lec::before {
          //   content: ':';
          //   margin-right: 12px;
          //   font-size: 34px;
          //   font-weight: 800;
          //   color: #979697;
          // }

          .box-lec {
            display: flex;
            flex-direction: column;
            padding-left: 28px;
            width: 100%;
            font-family: 'DB Helvethaica X 67 Cond';
            font-weight: 300;
            color: #979697;

            .box-lecturer::before {
              content: ':';
              margin-right: 12px;
              font-size: 34px;
              font-weight: 800;
              color: #979697;
            }

            .box-lecturer {
              p,span:first-child {
                margin-left: 0;
              }

              p,span {
                margin-left: 18px;
              }
            }
          }
        }
      }
    }
  }

  .wrap-other {
    border-top: 10px solid #D1D3D4;

    .title {
      padding-top: 22px;
      padding-bottom: 22px;
      width: 100%;
      font-family: 'DB HelvethaicaMon X';
      text-align: center;
      font-weight: 800;
      font-size: 28px;
    }

    .box-card {
      width: 100%;

      .box-section {
        margin-bottom: 32px;
        width: 100%;
        height: fit-content;

        a {
          .wrap-image {
            overflow: hidden;
            position: relative;
            width: 100%;
            padding-bottom: 56.25%;

            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
